import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GlobalBorrowerTabsSmartComponent } from './global-borrower-tabs-smart/global-borrower-tabs-smart.component';
import { MatTabsModule } from '@angular/material/tabs';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { AddNewLeadModule } from 'app/add-new-lead/add-new-lead.module';
import { RouterModule } from '@angular/router';
import { CloseTabsDialogComponent } from 'ng2-app/global-borrower-tabs/global-borrower-tabs-smart/close-tabs-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [
    GlobalBorrowerTabsSmartComponent,
    CloseTabsDialogComponent,
  ],
    imports: [
        AddNewLeadModule,
        CommonModule,
        MatButtonModule,
        MatDialogModule,
        MatIconModule,
        MatTabsModule,
        RouterModule,
        MatTooltipModule,
    ],
  exports: [
    GlobalBorrowerTabsSmartComponent
  ]
})
export class GlobalBorrowerTabsModule { }
